export const msg = {

    cropsLargerThanField: {
        summary: "Crops larger than the associated field",
        description: "The following crops are larger than their associated field"
    },

    cropsLargerThanField2: {
        summary: "Concurrent crops larger than the associated field",
        description: "The following groups of concurrent groups occupy an area larger than that of their field",
    },

    cropOutsideFieldBoundary: {
        summary: "Crop boundaries outside their field's boundary",
        description: "The boundaries of the following crops lie at least partially outside of their field's boundary"
    },

    cropBoundaryOverlaps: {
        summary: "Crop boundaries overlap",
        description: "The boundaries of the following crops overlap those of concurrent crops on the same field"
    },

    fieldBoundaryOverlaps: {
        summary: "Field boundaries overlap",
        description: "The boundaries of the following fields overlap those of other fields"
    },

    wrongYear: {
        summary: "Cropping year / dates mismatches",
        description: "The following crops have dates that do not match their cropping year",
    },

    startBeforeEnd: {
        summary: "Wrong cropping dates",
        description: "Check the dates for the following crops"
    },

    historyPrevNotSet: {
        summary: "Ambiguous cropping history",
        description: "The following crops each have multiple predecessors, any of which could be used as a previous crop in Nutrition. To clarify, please set the previous crop explicitely.",
    }


}
